var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Menu, { SubMenu, MenuItem } from 'rc-menu';

import { NavLink } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';

import { locationShape, TSS_DARK_BLUE, TSS_GREEN } from 'tss-core-lib-common';
// Override rc-menu style to allow self hosted font-awesome
import './rc-menu/style.css';
import './style.css';

var styles = void 0;

var itemShapeObj = {
  label: PropTypes.string,
  labelKey: PropTypes.string,
  url: locationShape,
  allowReloadNavigation: PropTypes.bool
};

var SideNavigation = function (_Component) {
  _inherits(SideNavigation, _Component);

  function SideNavigation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SideNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SideNavigation.__proto__ || Object.getPrototypeOf(SideNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openedMenu: ''
    }, _this.onClick = function (openedMenu) {
      _this.setState({ openedMenu: openedMenu });
    }, _this.item = function (item) {
      var disabled = !item.allowReloadNavigation && item.url === _this.props.location.pathname;
      var children = void 0;
      if (disabled) {
        children = React.createElement(
          'div',
          null,
          item.label
        );
      } else {
        children = item.companySettings ? React.createElement(
          'a',
          { href: item.url },
          item.label
        ) : React.createElement(
          NavLink,
          { to: item.url },
          item.label
        );
      }
      return React.createElement(
        MenuItem,
        {
          key: item.label + item.url,
          disabled: disabled
        },
        children
      );
    }, _this.processMenuItems = function (subItems) {
      return subItems.map(function (item) {
        if (item === null) {
          return null;
        }
        if (item.subItems === null) {
          return _this.item(item);
        }
        return React.createElement(
          SubMenu,
          { key: item.label + item.url, title: item.label },
          _this.processMenuItems(item.subItems)
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SideNavigation, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: css(styles.container) },
        React.createElement(
          Menu,
          { onSelect: this.onClick, mode: 'inline' },
          this.processMenuItems(this.props.items)
        )
      );
    }
  }]);

  return SideNavigation;
}(Component);

SideNavigation.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(Object.assign({}, itemShapeObj, {
    subItems: PropTypes.arrayOf(PropTypes.shape(itemShapeObj))
  }))).isRequired,
  location: locationShape.isRequired
};

SideNavigation.defaultProps = {};

styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    flex: '1 1 auto'
  },

  itemsList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0
  },

  nestedItemList: {
    margin: '1.6rem 0 0 0'
  },

  item: {
    margin: '2rem 0 0 0',
    ':first-child': {
      margin: 0
    }
  },

  link: {
    textDecoration: 'none',
    fontSize: '1.4rem',
    color: TSS_DARK_BLUE(),
    fontWeight: 600
  },

  activeLink: {
    color: TSS_GREEN()
  },

  subItem: {
    paddingLeft: '1.6rem'
  }
});

export default SideNavigation;